<div>
    <div class="row">
        <div class="col-xl-12">
            <div class="card-box">
                <div v-if="!loading">
                    <data-table :headings="areasHeadings" :data="areas" :hasActions="true"
                                :pagingDetails="pagingDetails"
                                :hasNoPaging="true"
                                :stateChanged="filterStateChanged"
                                @actionClicked="onAreaActionClicked" 
                                @filterSearchClicked="onFilterSearchClicked">
                        <template #actionButton>
                            <div class="w-100">
                                <button class="btn btn-primary" id="btnAddArea" @click="onAddAreaClick">Add Area</button>
                            </div>
                        </template>
                        <template #filter>
                            <div class="p-3">
                                <div class="input-group pb-4">
                                    <input type="text" class="form-control" placeholder="Search" aria-label="Search" aria-describedby="basic-addon1" v-model="filter.customerSearchQuery">
                                    <div class="input-group-append">
                                    <span class="input-group-text" id="basic-addon1">
                                        <i class="fas fa-search"></i>
                                    </span>
                                    </div>
                                </div>
                                <active-inactive-radio-buttons :activeInactiveKey="filter.activeOrInactiveItems"
                                                               :componentId="'customerFilterRadioButtons'"
                                                               @activeInactiveSelected="onActiveInactiveFilterSelected"></active-inactive-radio-buttons>
                            </div>
                        </template>
                    </data-table>
                </div>
                <loading-spinner :showSpinner="loading"></loading-spinner>
            </div>
        </div>
    </div>

    <mark-as-active-inactive-modal
                :heading="areaMarkAsActiveInactiveModal.heading"
                :modalId="areaMarkAsActiveInactiveModal.modalId"
                :isSaving="areaMarkAsActiveInactiveModal.isSaving"
                :showModal="areaMarkAsActiveInactiveModal.showModal"
                :isActive="areaMarkAsActiveInactiveModal.isActive"
                @closeClicked="areaMarkAsActiveInactiveModal.showModal = false"
                @saveButtonClicked="onMarkAsActiveInactiveSaveClick"></mark-as-active-inactive-modal>
    
    <modal-form
            :heading="areaAddEditFormModal.heading"
            :modalId="areaAddEditFormModal.modalId"
            :isSaving="areaAddEditFormModal.isSaving"
            :showModal="areaAddEditFormModal.showModal"
            @closeClicked="onAddOrEditAreaModalCloseClick"
            @saveButtonClicked="onAddOrEditAreaSaveClick">
        <template #form>
            <form>
                <div class="form-group">
                    <label for="shippingAreaInput">
                        Shipping Area
                    </label>
                    <div class="text-danger" v-if="areaAddEditFormModal.area.shippingArea.hasError">
                       {{areaAddEditFormModal.area.shippingArea.errorMessage}} 
                    </div>
                    <input class="form-control" id="shippingAreaInput" v-model="areaAddEditFormModal.area.shippingArea.value">
                </div>
            </form>
        </template>
    </modal-form>
</div>
